// extracted by mini-css-extract-plugin
export default {"imgBox":"BountyBannerLogo_imgBox__KtXWR","logo":"BountyBannerLogo_logo__gdRPQ"};